import {
  CreatePayrollPolicyWithEmployeesDocument,
  CreatePayrollPolicyWithEmployeesMutation,
  CreatePayrollPolicyWithEmployeesMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreatePayrollPolicyWithEmployeesPayload =
  CreatePayrollPolicyWithEmployeesMutation['payrollMutations']['createWithEmployeesPayrollPolicy']

export const useCreatePayrollPolicyWithEmployees = () => {
  const [CreatePayrollPolicyWithEmployees, { loading }] = useMutation(
    CreatePayrollPolicyWithEmployeesDocument,
    {
      extractorFn: (data: CreatePayrollPolicyWithEmployeesMutation) =>
        data.payrollMutations.createWithEmployeesPayrollPolicy,
    }
  )

  return {
    loading,
    CreatePayrollPolicyWithEmployees(variables: CreatePayrollPolicyWithEmployeesMutationVariables) {
      return CreatePayrollPolicyWithEmployees({
        variables,
      })
    },
  }
}
